import EN from "./en"
import RO from "./ro"
import DE from "./de"
import ES from "./es"
import FR from "./fr"
import IT from "./it"
import RU from "./ru"

const contents = {
    en: EN,
    ro: RO,
    de: DE,
    es: ES,
    fr: FR,
    it: IT,
    ru: RU,
}

export default contents;